<template>
  <div>
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">Solicitações de marcações pendentes</div>
      </div>
      <div class="card-body">
        <div class="row" v-if="transportationRequests.length">
          <div
            v-for="transportationRequest in transportationRequests"
            :key="transportationRequest.id"
            class="col-md-6 offset-md-3 check-request-card"
          >
            <div class="row mb-3">
              <div class="col-md-9">
                <h6>
                  <b>Colaborador: </b>
                  {{ transportationRequest.user.name }}
                </h6>
                <h6>
                  <b>Data e hora: </b>
                  {{ format(transportationRequest.date) }}
                </h6>
                <div v-if="reprovingIds.includes(transportationRequest.id)">
                </div>
              </div>
              <div class="col-md-3">
                <div v-show="!reprovingIds.includes(transportationRequest.id)">
                  <button
                    class="btn btn-yes btn-block"
                    :disabled="disabled"
                    @click="approve(2, transportationRequest)"
                  >
                    Aprovar
                  </button>
                  <button
                    class="btn btn-no btn-block"
                    :disabled="disabled"
                    @click="justify(transportationRequest)"
                  >
                    Reprovar
                  </button>
                </div>
                <div v-show="reprovingIds.includes(transportationRequest.id)">
                  <button
                    class="btn btn-yes btn-block"
                    :disabled="disabled"
                    @click="approve(3, transportationRequest)"
                  >
                    Enviar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="!transportationRequests.length">
          <div class="col-md-6 offset-md-3">
            <div class="alert alert-primary" role="alert">
              Nenhuma solicitação pendente!
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      transportationRequests: [],
      reprovingIds: [],
      departments:[],
      disabled: false,
    };
  },
  methods: {
    justify(transportationRequest) {
      const self = this;
      let index = self.reprovingIds.findIndex((x) => x == transportationRequest.id);
      if (index !== -1) {
        self.reprovingIds.splice(index, 1);
      } else {
        self.reprovingIds.push(transportationRequest.id);
      }
    },
    approve(status_id, transportationRequest) {
      const self = this;
      self.disabled = true;
      const api = self.$store.state.api + "transport_solicitations/approve/";
      self.$http
        .post(api, {
          status_id: status_id,
          id: transportationRequest.id
        })
        .then((response) => {
          self.getData();
          self.$message("Sucesso", "Dados registrados com sucesso", "success");
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    format(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    getData() {
      const self = this;
      const api =
        self.$store.state.api +
        "transport_solicitations?status_id=1&with[]=user&paginated=false";
      self.$http
        .get(api)
        .then((response) => {
          self.transportationRequests = response.data.data;
          self.disabled = false;
        })
        .catch((error) => {
          self.message("Erro", error.response.data, "error");
        });
    },
    getDepartments() {
      const self = this;
      const api =
        self.$store.state.api +
        "departments";
      self.$http
        .get(api)
        .then((response) => {
          console.log('departamentos');
          console.log(response)
          self.departments = response.data.data;
        
        })
        .catch((error) => {
          self.message("Erro", error.response.data, "error");
        });
    },
  },
  mounted() {
    const self = this;
    self.getData();
    self.getDepartments();
  },
};
</script>

<style scoped>
.check-request-card {
  border-radius: 10px;
  border: 1px solid black;
  margin-bottom: 5px;
  background-color: white;
  padding-top: 10px;
}
/* .check-request-card:hover {
    } */
.btn-yes {
  border: 1px solid #2ea2cd;
  background-color: white;
  color: #2ea2cd;
}
.btn-yes:hover {
  border-radius: 1px solid white;
  background-color: #2ea2cd;
  color: white;
}

.btn-no {
  border: 1px solid rgb(255, 70, 70);
  background-color: white;
  color: rgb(255, 70, 70);
}
.btn-no:hover {
  border-radius: 1px solid white;
  background-color: rgb(255, 70, 70);
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/TransportationRequest/Approve.vue